<script lang="ts">
  import { useSubscriptionConfig } from '@/utils/use-subscription-config.svelte';

  import LoginForm from './cmps/LoginForm.svelte';
  import LoginLoading from './cmps/LoginLoading.svelte';

  const config = useSubscriptionConfig();

  const { data, error, loading } = $derived(config.current);
</script>

{#if loading}
  <LoginLoading />
{/if}

{#if error}
  <div class="flex flex-col items-center gap-3">
    <h1 class="text-[20px] font-bold text-c-error">Fehler:</h1>
    <p class="text-lg">{error.message}</p>
  </div>
{/if}

{#if data && !loading}
  <LoginForm config={data} />
{/if}
